// btw-front/src/lib/dealRegistrationGate.js
// 딜 등록 제한 안내 — 관리자가 파트너사의 신규 딜 등록을 막았을 때 쓰는 공용 훅.
// 최종 차단은 서버(POST /api/partner/deals → 403 DEAL_REGISTRATION_BLOCKED)가 하고,
// 여기서는 등록 버튼 단계에서 먼저 안내 팝업을 띄워 헛걸음을 막는다.
// 로그인 세션이 오래돼 플래그가 없으면(undefined) 통과시키고 서버 응답으로 안내한다.
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePartnerSession } from "../context/PartnerSessionContext";

export function useDealRegistrationGate() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { profile } = usePartnerSession();

  const blocked = !!profile && profile.canRegisterDeal === false;

  function showBlockedNotice() {
    Modal.warning({
      title: t("partners.deals.blocked.title"),
      content: t("partners.deals.blocked.body"),
      okText: t("partners.deals.blocked.ok"),
    });
  }

  // 등록 버튼 클릭 — 제한이면 안내 팝업, 아니면 등록 페이지로 이동
  function goToNewDeal() {
    if (blocked) return showBlockedNotice();
    navigate("/partners/deals/new");
  }

  return { blocked, goToNewDeal, showBlockedNotice };
}
